// AppPermissions.ts
export class AppPermissions {
  static types = {
    tazmeenEmployee: 'taz_emp',
    clientEmployee: 'cl_emp',
  };
  static roles = {
    ClientAdmin: 'ClAd',
    TazmeenScript: 'TzSc',
    QcEmp: 'QcEmp',
  };
}
